export default {
  getUsers (state) {
    return state.users
  },
  getAllInterviews (state) {
    return state.all_interviews
  }
}
